import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DatePicker, Space } from "antd";
import moment from "moment";
import userIcon from "../../assets/images/user-icon-removebg.png";
import BothReviewsModal from "../../components/bothReviewModal/bothReviewModal";
import {
  getOfferSlotsByDateClosed,
  getOfferSlotsByDateDisputed,
  getOfferSlotsByDatePastAndUpcoming,
} from "../../services/auth";
import dayjs from "dayjs";
import { TabState } from "./classes.constants";
import "./style.css";
import AdminGrid from "../../components/adminGrid/adminGrid";

function Classes() {
  const { id: currentSection } = useParams();
  const navigate = useNavigate();
  const [isBothReviewsModalVisible, setIsBothReviewsModalVisible] =
    useState(false);
  const [rowDataPast, setRowDataPast] = useState([]);
  const [rowDataDisputed, setRowDataDisputed] = useState([]);
  const [rowDataClose, setRowDataClose] = useState([]);
  const [rowDataUpcoming, setRowDataUpcoming] = useState([]);
  const [loading, setLoading] = useState(false);
  const [date, setDate] = useState();
  const [teachingMode, setTeachingMode] = useState("both");

  useLayoutEffect(() => {
    switch (currentSection) {
      case TabState.Past:
      case TabState.Close:
        setDate(dayjs().subtract(1, "day"));
        break;
      case TabState.Upcoming:
      case TabState.Disputed:
        setDate(dayjs());
        break;
      default:
        setDate(dayjs());
        break;
    }
  }, [currentSection]);

  useLayoutEffect(() => {
    setRowDataClose([]);
    setRowDataDisputed([]);
    setRowDataPast([]);
    setRowDataUpcoming([]);
  }, [currentSection]);

  const navigateTo = (path) => {
    navigate(`/classes/${path}`);
  };

  const handleTeachingModeChange = (mode) => {
    setTeachingMode(mode);
  };

  const fetchData = useCallback(
    async (date) => {
      try {
        setLoading(true);
        let api, setter;

        switch (currentSection) {
          case TabState.Past:
            setter = setRowDataPast;
            api = getOfferSlotsByDatePastAndUpcoming;
            break;
          case TabState.Upcoming:
            setter = setRowDataUpcoming;
            api = getOfferSlotsByDatePastAndUpcoming;
            break;
          case TabState.Disputed:
            setter = setRowDataDisputed;
            api = getOfferSlotsByDateDisputed;
            break;
          case TabState.Close:
            setter = setRowDataClose;
            api = getOfferSlotsByDateClosed;
            break;
          default:
        }

        if (!api || !setter) return;

        const { data } = await api(date);
        const rows = data.data || [];

        // Apply teaching mode filter
        const filteredRows = rows.filter((row) => {
          return teachingMode === "both" || row.teachingMode === teachingMode;
        });

        setter(filteredRows);
        setLoading(false);
      } catch (error) {
        // Handle error
      } finally {
        setLoading(false);
      }
    },
    [currentSection, teachingMode]
  );

  // const fetchData = useCallback(
  //   async (date) => {
  //     try {
  //       setLoading(true);
  //       let api, setter;

  //       switch (currentSection) {
  //         case TabState.Past:
  //           setter = setRowDataPast;
  //           api = getOfferSlotsByDatePastAndUpcoming;
  //           break;
  //         case TabState.Upcoming:
  //           setter = setRowDataUpcoming;
  //           api = getOfferSlotsByDatePastAndUpcoming;
  //           break;
  //         case TabState.Disputed:
  //           setter = setRowDataDisputed;
  //           api = getOfferSlotsByDateDisputed;
  //           break;
  //         case TabState.Close:
  //           setter = setRowDataClose;
  //           api = getOfferSlotsByDateClosed;
  //           break;
  //         default:
  //       }

  //       if (!api || !setter) return;

  //       const { data } = await api(date);

  //       const rows = data.data || [];

  //       setter(rows);
  //       setLoading(false);
  //     } catch (error) {
  //     } finally {
  //       setLoading(false);
  //     }
  //   },
  //   [currentSection]
  // );

  useEffect(() => {
    if (!date) return;
    const formattedDate = date.format("YYYY-MM-DD");
    fetchData(formattedDate);
  }, [date, teachingMode]);

  // Grid
  const centerStyle = {
    display: "flex",
    alignItems: "center",
  };

  const teacherCellRenderer = ({ data }) => (
    <ImageAndNameRenderer value={data.teacher} />
  );

  const studentCellRenderer = ({ data }) => (
    <ImageAndNameRenderer value={data.student} />
  );

  const actionCellRenderer = () => (
    <button
      className="btn btn-primary btn_contained btn-sm fs_12"
      onClick={() => {
        console.log("Review Opened");
        bothReviewsModal();
      }}
    >
      View
    </button>
  );

  const getRowHeight = (params) => {
    var Heights = [60, 60, 60, 60];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  // DataPast
  const columnDefsPast = [
    {
      headerName: "Teacher",
      field: "teacher.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["teacher.fullName"] || "",
    },
    {
      headerName: "Subject",
      field: "courses",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      cellRenderer: (params) => {
        const courses = params.data?.courses || [];
        // Extract the courseSubjectName from each course object and join them with commas
        return courses.length > 0
          ? courses.map((course) => course.courseSubjectName).join(", ")
          : "N/A";
      },
    },
    {
      headerName: "Student",
      field: "student.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["student.fullName"] || "",
    },
    {
      headerName: "Offer Type",
      field: "offerType",
      flex: 1,
      cellStyle: centerStyle,
    },
    {
      headerName: "Date",
      field: "offerSlots.date",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["offerSlots.date"] || "",
    },
  ];
  // DataPast

  // DataDisputed
  const columnDefsDisputed = [
    {
      headerName: "Teacher",
      field: "teacher.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["teacher.fullName"] || "",
    },
    {
      headerName: "Subject",
      field: "courses",
      flex: 1,
      filter: true,
      cellStyle: centerStyle,
      cellRenderer: (params) => {
        const courses = params.data?.courses || [];
        // Extract the courseSubjectName from each course object and join them with commas
        return courses.length > 0
          ? courses.map((course) => course.courseSubjectName).join(", ")
          : "N/A";
      },
    },
    {
      headerName: "Student",
      field: "student.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["student.fullName"] || "",
    },
    {
      headerName: "Offer Type",
      field: "offerType",
      flex: 1,
      cellStyle: centerStyle,
    },
    {
      headerName: "Date",
      field: "offerSlots.date",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["offerSlots.date"] || "",
    },
    // {
    //   headerName: "",
    //   field: "view",
    //   width: 120,
    //   cellStyle: centerStyle,
    //   cellRenderer: actionCellRenderer,
    // },
  ];
  // DataDisputed

  // DataClosed
  const columnDefsClose = [
    {
      headerName: "Teacher",
      field: "teacher.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["teacher.fullName"] || "",
      // cellRenderer: teacherCellRenderer,
    },
    {
      headerName: "Subject",
      field: "extraSubjects",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => {
        const subjects = params.data?.["extraSubjects"] || [];
        return subjects.map((subject) => subject.subjectName).join(", ");
      },
    },
    {
      headerName: "Student",
      field: "student.fullName",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["student.fullName"] || "",
      // cellRenderer: studentCellRenderer,
    },
    // {
    //   headerName: "Level",
    //   field: "level",
    //   cellStyle: centerStyle,
    //   flex: 1,
    // },
    {
      headerName: "Offer Type",
      field: "offerType",
      flex: 1,
      cellStyle: centerStyle,
    },
    {
      headerName: "Date",
      field: "offerSlots.date",
      flex: 1,
      cellStyle: centerStyle,
      valueGetter: (params) => params.data?.["offerSlots.date"] || "",
    },
  ];
  // DataClosed

  const ImageAndNameRenderer = ({ value }) => (
    <div className="d-flex align-items-center">
      <img
        src={value.image}
        alt="profileimg"
        style={{
          width: "35px",
          height: "35px",
          borderRadius: "50%",
          border: "2px solid white",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          marginTop: "10px",
        }}
      />
      <div>
        <span
          style={{
            marginLeft: "8px",
            marginBottom: "-15px",
            display: "block",
          }}
        >
          {value.name}
        </span>
      </div>
    </div>
  );

  const bothReviewsModal = () => {
    setIsBothReviewsModalVisible(true);
  };

  const today = moment().startOf("day");
  const upcomingCutOffDate = moment().add(0, "days");
  const disabledDate = (current) => {
    if (!current) {
      return false;
    }

    if (currentSection === "upcoming") {
      return current.isBefore(upcomingCutOffDate, "day");
    } else {
      return current.isAfter(today, "day");
    }
  };

  const formatTime = (timeString) => {
    if (!timeString) return "N/A";

    const [hours, minutes] = timeString.split(":");
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";

    hour = hour % 12;
    hour = hour || 12;

    const formattedTime = `${hour.toString().padStart(2, "0")}:${minutes}`;
    return `${formattedTime} ${ampm}`;
  };

  const onChange = (date, dateString) => {
    setDate(date);
  };

  const isPast = currentSection === TabState.Past;
  const isUpcoming = currentSection === TabState.Upcoming;
  const isDisputed = currentSection === TabState.Disputed;
  const isClose = currentSection === TabState.Close;

  return (
    <>
      {/* <ClassesCards /> */}
      <div className="d-flex justify-content-between align-items-center px-3">
        <h3 className="h3">Classes</h3>
        <div className="fs_16">
          {/* Classes found in{" "} */}
          {/* {currentSection.charAt(0).toUpperCase() + currentSection.slice(1)} */}
        </div>
        <div className="d-flex align-items-center">
          <div className="mr-3">
            <Space direction="vertical">
              <DatePicker
                value={date}
                onChange={onChange}
                format="YYYY-MM-DD"
                disabledDate={disabledDate}
                style={{ width: 150 }}
              />
            </Space>
          </div>
          <div
            className="btn-group btn-sm"
            role="group"
            aria-label="Basic example"
          >
            <button
              type="button"
              onClick={() => navigateTo("past")}
              className={`btn btn-sm ${
                currentSection === "past"
                  ? "btn_contained_black text-white"
                  : "btn_outlined text-dark"
              }`}
            >
              Past
            </button>
            <button
              type="button"
              onClick={() => navigateTo("upcoming")}
              className={`btn btn-sm ${
                currentSection === "upcoming"
                  ? "btn_contained_black text-white"
                  : "btn_outlined text-dark"
              }`}
            >
              Upcoming
            </button>
            <button
              type="button"
              onClick={() => navigateTo("disputed")}
              className={`btn btn-sm ${
                currentSection === "disputed"
                  ? "btn_contained_black text-white"
                  : "btn_outlined text-dark"
              }`}
            >
              Disputed
            </button>
            <button
              type="button"
              onClick={() => navigateTo("close")}
              className={`btn btn-sm ${
                currentSection === "close"
                  ? "btn_contained_black text-white"
                  : "btn_outlined text-dark"
              }`}
            >
              Closed
            </button>
          </div>
        </div>
      </div>
      {/* Filter With Home/Online/Both */}
      <div className="pl-2 pt-3">
        <div
          className="btn-group btn-sm"
          role="group"
          aria-label="Basic example"
        >
          <button
            type="button"
            onClick={() => handleTeachingModeChange("home")}
            className={`btn btn-sm ${
              teachingMode === "home"
                ? "btn_contained_black text-white"
                : "btn_outlined text-dark"
            }`}
          >
            Home
          </button>
          <button
            type="button"
            onClick={() => handleTeachingModeChange("online")}
            className={`btn btn-sm ${
              teachingMode === "online"
                ? "btn_contained_black text-white"
                : "btn_outlined text-dark"
            }`}
          >
            Online
          </button>
          <button
            type="button"
            onClick={() => handleTeachingModeChange("both")}
            className={`btn btn-sm ${
              teachingMode === "both"
                ? "btn_contained_black text-white"
                : "btn_outlined text-dark"
            }`}
          >
            Both
          </button>
        </div>
      </div>
      {isPast && (
        <div className="row px-3 pt-3">
          {loading ? (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : rowDataPast.length ? (
            rowDataPast.map((cls, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4 pt-3">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      backgroundColor: "#f5fdff",
                      borderRadius: "6px",
                    }}
                  >
                    <h5 className="card-title">
                      <div className="row">
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                      </div>
                    </h5>
                    <div className="row">
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Teacher Name
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Student Name
                        </span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["teacher.fullName"]}
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["student.fullName"]}
                        </span>
                      </div>
                    </div>
                    <div className="row pt-3 align-items-center">
                      <div className="col-6">
                        <span className="fs_12 fw-normal">Subject</span>
                      </div>
                      <div className="col-6 pt-1">
                        <span className="fs_12 fw-bold">
                          {cls.extraSubjects && cls.extraSubjects.length > 0 ? (
                            cls.extraSubjects.map((subject) => (
                              <li
                                className="list-unstyled"
                                key={subject.subjectId}
                              >
                                {subject.subjectName || "N/A"}
                              </li>
                            ))
                          ) : (
                            <span>N/A</span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="card_bg p-2 mt-3 rounded">
                      <span className="fs_12">Meeting Time</span>
                      <br />
                      <span className="fs_12 mt-1 d-flex justify-content-between">
                        <span>{formatTime(cls?.["offerSlots.startTime"])}</span>
                        <span>{cls?.["offerSlots.date"]}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No data found
            </div>
          )}
        </div>
        // <AdminGrid
        //   row={rowDataPast}
        //   cols={columnDefsPast}
        //   rowClass={"fs_12"}
        //   gridOptions={gridOptions}
        //   style={{ height: "100vh" }}
        //   pagination={true}
        // />
      )}
      {isUpcoming && (
        <div className="row px-3 pt-3">
          {loading ? (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : rowDataUpcoming.length ? (
            rowDataUpcoming.map((cls, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4 pt-3">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      backgroundColor: "#f5fdff",
                      borderRadius: "6px",
                    }}
                  >
                    <h5 className="card-title">
                      <div className="row">
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                      </div>
                    </h5>
                    <div className="row">
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Teacher Name
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Student Name
                        </span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["teacher.fullName"]}
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["student.fullName"]}
                        </span>
                      </div>
                    </div>
                    <div className="row pt-3 align-items-center">
                      <div className="col-6">
                        <span className="fs_12 fw-normal">Subject</span>
                      </div>
                      <div className="col-6 pt-1">
                        <span className="fs_12 fw-bold">
                          {cls.extraSubjects && cls.extraSubjects.length > 0 ? (
                            cls.extraSubjects.map((subject) => (
                              <li
                                className="list-unstyled"
                                key={subject.subjectId}
                              >
                                {subject.subjectName || "N/A"}
                              </li>
                            ))
                          ) : (
                            <span>N/A</span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="card_bg p-2 mt-3 rounded">
                      <span className="fs_12">Meeting Will Start</span>
                      <br />
                      <span className="fs_12 mt-1 d-flex justify-content-between">
                        <span>{formatTime(cls?.["offerSlots.startTime"])}</span>
                        <span>{cls?.["offerSlots.date"]}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No data found
            </div>
          )}
        </div>
      )}
      {isDisputed && (
        <div className="row px-3 pt-3">
          {loading ? (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : rowDataDisputed.length ? (
            rowDataDisputed.map((cls, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4 pt-3">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      backgroundColor: "#f5fdff",
                      borderRadius: "6px",
                    }}
                  >
                    <h5 className="card-title">
                      <div className="row">
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                      </div>
                    </h5>
                    <div className="row">
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Teacher Name
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Student Name
                        </span>
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["teacher.fullName"]}
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["student.fullName"]}
                        </span>
                      </div>
                    </div>
                    <div className="row pt-3 align-items-center">
                      <div className="col-6">
                        <span className="fs_12 fw-normal">Subject</span>
                      </div>
                      <div className="col-6 pt-1">
                        <span className="fs_12 fw-bold">
                          {cls.extraSubjects && cls.extraSubjects.length > 0 ? (
                            cls.extraSubjects.map((subject) => (
                              <li
                                className="list-unstyled"
                                key={subject.subjectId}
                              >
                                {subject.subjectName || "N/A"}
                              </li>
                            ))
                          ) : (
                            <span>N/A</span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="card_bg p-2 mt-3 rounded">
                      <span className="fs_12">Meeting Time</span>
                      <br />
                      <span className="fs_12 mt-1 d-flex justify-content-between">
                        <span>{formatTime(cls?.["offerSlots.startTime"])}</span>
                        <span>{cls?.["offerSlots.date"]}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No data found
            </div>
          )}
        </div>

        // <AdminGrid
        //   row={rowDataDisputed}
        //   cols={columnDefsDisputed}
        //   rowClass={"fs_12"}
        //   gridOptions={gridOptions}
        //   style={{ height: "100vh" }}
        //   pagination={true}
        // />
      )}
      {isClose && (
        <div className="row px-3 pt-3">
          {loading ? (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Loading...
            </div>
          ) : rowDataClose?.length ? (
            rowDataClose.map((cls, index) => (
              <div key={index} className="col-lg-3 col-md-4 col-sm-6 mb-4 pt-3">
                <div className="card">
                  <div
                    className="card-body"
                    style={{
                      backgroundColor: "#f5fdff",
                      borderRadius: "6px",
                    }}
                  >
                    <h5 className="card-title">
                      <div className="row">
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                        <div className="col-6">
                          <img
                            className="shadow rounded-circle"
                            src={userIcon}
                            alt=""
                            style={{ border: "2px solid white", width: "60px" }}
                          />
                        </div>
                      </div>
                    </h5>
                    <div className="row">
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Teacher Name
                        </span>
                        {/* <img
                          src={chatIcon}
                          alt=""
                          style={{
                            width: 20,
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            console.log("Chat Clicked !");
                          }}
                        /> */}
                      </div>
                      <div className="col-6">
                        <span className="fs_12 text-secondary">
                          Student Name
                        </span>
                        {/* <img
                          src={chatIcon}
                          alt=""
                          style={{
                            width: 20,
                            marginLeft: "5px",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            console.log("Chat Clicked !");
                          }}
                        /> */}
                      </div>
                    </div>
                    <div className="row pt-1">
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["teacher.fullName"]}
                        </span>
                      </div>
                      <div className="col-6">
                        <span className="fs_12 fw-bold">
                          {cls?.["student.fullName"]}
                        </span>
                      </div>
                    </div>
                    <div className="row pt-3 align-items-center">
                      <div className="col-6">
                        <span className="fs_12 fw-normal">Subject</span>
                      </div>
                      <div className="col-6 pt-1">
                        <span className="fs_12 fw-bold">
                          {cls.extraSubjects && cls.extraSubjects.length > 0 ? (
                            cls.extraSubjects.map((subject) => (
                              <li
                                className="list-unstyled"
                                key={subject.subjectId}
                              >
                                {subject.subjectName || "N/A"}
                              </li>
                            ))
                          ) : (
                            <span>N/A</span>
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="card_bg p-2 mt-3 rounded">
                      <span className="fs_12">Meeting Time</span>
                      <br />
                      <span className="fs_12 mt-1 d-flex justify-content-between">
                        <span>{formatTime(cls?.["offerSlots.startTime"])}</span>
                        <span>{cls?.["offerSlots.date"]}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                display: "flex",
                paddingLeft: "30px",
                height: "200px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No data found
            </div>
          )}
        </div>
        // <AdminGrid
        //   row={rowDataClose}
        //   cols={columnDefsClose}
        //   rowClass={"fs_12"}
        //   gridOptions={gridOptions}
        //   style={{ height: "100vh" }}
        //   pagination={true}
        // />
      )}
      <BothReviewsModal
        isModalVisible={isBothReviewsModalVisible}
        setIsModalVisible={setIsBothReviewsModalVisible}
      />
    </>
  );
}

export default Classes;
